<script>

export default {
  name: 'HeaderSection',
  data() {
    return {
      loading:false,
      auth_name:"",
      new_message_count:"",
    }
  },
  components: {
  },
  mounted() {
    this.auth_name=localStorage.getItem("auth_name");
    this.getNewCount();
  }, 
  methods: {
      async getNewCount() {
        try{
          const response = await this.$axios.get('/Message/newCount');
          this.new_message_count=response.data.count;
        }
        catch(error){ 
          error;
          //this.MyPageAlert.status="error";
          //this.MyPageAlert.message=error.message;
         
        }
        setTimeout(() => {
           this.getNewCount();
        }, 10000);        
      },     
     async Logout(){
        try{
          const response = await this.$axios.post('/auth/logout',this.row)
          if(response.data){
            localStorage.removeItem("access_token","");
            this.$router.push({name:"Login"});
          } 
        }
        catch(error){ 
          error;
          //this.MyPageAlert.status="error";
          //this.MyPageAlert.message=error.message;
          this.loading=false; 
        }         
     }
  }
}
</script>
<style>
  header{
    background-color:var(--wpx-primary);
  }
</style>
<template>
  <header class="text-white">
    <nav class="navbar navbar-expand-md navbar-light bg-light2">
      
      <div class="container-fluid">
        <a href="#" class="navbar-brand">
              <img src="../assets/images/logo.png" alt="Bootstrap logo" class="me-2">
        </a>
          

             
  
        <button id="navbar-toggler" class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#MyNavbar" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>        
        <div class=" collapse navbar-collapse" id="navbarCollapse">
             <RouterLink class="ms-auto text-center " :to="{name:'MessageList'}">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="black" class="bi bi-envelope-plus-fill" viewBox="0 0 16 16">
                <path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414zM0 4.697v7.104l5.803-3.558zM6.761 8.83l-6.57 4.026A2 2 0 0 0 2 14h6.256A4.5 4.5 0 0 1 8 12.5a4.49 4.49 0 0 1 1.606-3.446l-.367-.225L8 9.586zM16 4.697v4.974A4.5 4.5 0 0 0 12.5 8a4.5 4.5 0 0 0-1.965.45l-.338-.207z"/>
                <path d="M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0m-3.5-2a.5.5 0 0 0-.5.5v1h-1a.5.5 0 0 0 0 1h1v1a.5.5 0 0 0 1 0v-1h1a.5.5 0 0 0 0-1h-1v-1a.5.5 0 0 0-.5-.5"/>
              </svg>
              <span v-if="new_message_count>0" class="badge bg-danger">{{new_message_count}}</span>
            </RouterLink>
          <ul class="  navbar-nav  ">
         
            <li class="nav-item dropdown">
             
              <a href="#" class="text-white nav-link dropdown-toggle" id="userDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">

               
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-person-circle" viewBox="0 0 16 16">
                  <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0"/>
                  <path fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1"/>
                </svg>
                
                {{auth_name}} 
              </a>
              <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="userDropdown">
                <li>
                  <RouterLink class="dropdown-item" :to="{name:'MyProfile'}">
                    Profil
                  </RouterLink>
                </li>
                <li>
                  <RouterLink class="dropdown-item" :to="{name:'Setting'}">
                    Ayarlar
                  </RouterLink>
                </li>
                <li><hr class="dropdown-divider"></li>
                <li><a @click.prevent="Logout()" href="#" class="dropdown-item">Çıkış</a></li>
                
              </ul>
              
            </li>
            
           
          </ul>
          
        </div>
        
      </div>
    </nav>
  </header>
</template>